
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import {ScanforOutBound_GetOffModule} from "@/store/modules/store_scanforoutbound_getoff";
import {queryLockWeight} from "@/api/service";
import {SystemConfigModule} from "@/store/modules/store_systemconfig";
import ReconnectingWebSocket from "reconnecting-websocket";
import {ScanforSixScanModule} from "@/store/modules/store_scanforsixscan";

@Component({
  name: "Form1",
})
export default class extends Vue {
  @Prop() private form!: OnCodeGetReqVo;
  @Prop() public ioTypes!: ioTypes_Array_Data[];
  private globalConfig: any = {};
  private lockLengthWidthHeightShow = false;
  private timer;

  private IsSixScan = false;
  private ScanforOutBound_GetOffModule: any;

  @Watch("lockLengthWidthHeight", {deep: true})
  onChildChanged(val: boolean) {
    this.form.LWHDisable = val;
  }

  private p2: any = {
    Width: '',
    Length: '',
    Height: '',
  };

  get packageWidth() {
    return this.form.PackageSize.Width || this.p2.Width;
  }

  get packageLength() {
    return this.form.PackageSize.Length || this.p2.Length;
  }

  get packageHeight() {
    return this.form.PackageSize.Height || this.p2.Height;
  }

  get noReadLablel() {
    return ScanforOutBound_GetOffModule.noReadLablel;
  }
  get noLittleNoLabel() {
    return ScanforOutBound_GetOffModule.noLittleNoLabel;
  }
  get overTimeLabel() {
    return ScanforOutBound_GetOffModule.overTimeLabel;
  }
  get manyCodeLabel() {
    return ScanforOutBound_GetOffModule.manyCodeLabel;
  }
  get LittleNoLabel() {
    return ScanforOutBound_GetOffModule.LittleNoLabel;
  }


  set packageWidth(val) {
    this.form.PackageSize.Width = val;
  }

  set packageLength(val) {
    this.form.PackageSize.Length = val;
  }

  set packageHeight(val) {
    this.form.PackageSize.Height = val;
  }


  private ytoWs: ReconnectingWebSocket = null;

  private mounted() {
    let _this = this;
    if (typeof obj_ScanForOutbound_GetOff !== "undefined") {
      obj_ScanForOutbound_GetOff.registerJavaScriptCallback(
        "setcarNumInfo",
        (value) => {
          //_this.carNumInfo = value;
          _this.form.CarNumInfo = value;
        }
      );
      // obj_ScanForOutbound_GetOff.regist_datahistorycallback('GetCarNumInfo',(b)=>{return _this.form.CarNumInfo});
    }
    debugger;
    if (typeof obj_GlobalData_Core !== "undefined") {
      this.globalConfig = SystemConfigModule.globalData;
      if (this.globalConfig.CurrentDeviceType == 4) {
        this.timer = null;
        this.timer = setInterval(() => {
          if (this.GetQueryLockWeight()) {
            //返回000 表示可以进行重量锁定
            this.lockLengthWidthHeightShow = true;
          } else {
            this.lockLengthWidthHeightShow = false;
            this.lockLengthWidthHeight = false;
            this.form.LWHDisable = false;
          }
        }, 3600000); //定时1个小时检查一次

        if (this.GetQueryLockWeight()) {
          // if (true) {//测试用，上线前需要注释
          this.lockLengthWidthHeightShow = true;
        }
      }
    }
    if (SystemConfigModule.currentDeviceType == 14) {
      this.ytoWs = new ReconnectingWebSocket('ws://localhost:47100', [], {debug: false});
      this.ytoWs.onmessage = function (e) {
        try {
          let obj = JSON.parse(e.data);
          if (obj.action === "packageval") {
            let packageval = obj.value;
            _this.p2.Height = packageval.height;
            _this.p2.Width = packageval.width;
            _this.p2.Length = packageval.length;
          }
        } catch (e) {
          console.log(e)
        }
      }
    }

    if (typeof obj_ScanForOutbound_GetOff !== "undefined")
    {
      obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetIsSixScan', (value) => {
        console.log("是否是六面扫：" + this.IsSixScan);
        this.IsSixScan = value;
        console.log("369" + ScanforOutBound_GetOffModule.isSixScanMode);
        ScanforOutBound_GetOffModule.setSixScanState(value);
        console.log("371" + ScanforOutBound_GetOffModule.isSixScanMode);
      });
    }
  }

  get LockedCarSignNumShow() {
    this.form.LockedCarSignNum = false;
    return ScanforOutBound_GetOffModule.lockedCarSignNumShow;
  }

  // set LockedCarSignNumShow(show) {
  //   ScanforOutBound_GetOffModule.setLockedCarSignNumShow(show);
  // }

  get lockLengthWidthHeight() {
    return ScanforOutBound_GetOffModule.lockLengthWidthHeight;
  }

  set lockLengthWidthHeight(lockResult) {
    ScanforOutBound_GetOffModule.setLockLengthWidthHeight(lockResult);
  }

  public loseFcousInputWeight() {
    if (this.form.PackageSize.InputWeight.toString() == "") {
      this.form.PackageSize.InputWeight = 0;
    }
  }

  public loseFcousLength() {
    if (this.form.PackageSize.Length.toString() == "") {
      this.form.PackageSize.Length = 0;
    }
  }

  public loseFcousWidth() {
    if (this.form.PackageSize.Width.toString() == "") {
      this.form.PackageSize.Width = 0;
    }
  }

  public loseFcousHeight() {
    if (this.form.PackageSize.Height.toString() == "") {
      this.form.PackageSize.Height = 0;
    }
  }

  public lockFunc(checked) {
    if (checked) {
      debugger;
      if (
        this.form.PackageSize.Length == 0 ||
        this.form.PackageSize.Width == 0 ||
        this.form.PackageSize.Height == 0
      ) {
        debugger;
        this.$nextTick(() => {
          this.lockLengthWidthHeight = false;
        });
        ScanforOutBound_GetOffModule.setErrorMessage("长宽高不能为0");
        return;
      }
      if (
        this.form.PackageSize.Length > 500 ||
        this.form.PackageSize.Width > 500 ||
        this.form.PackageSize.Height > 500
      ) {
        this.$nextTick(() => {
          this.lockLengthWidthHeight = false;
          ScanforOutBound_GetOffModule.setErrorMessage(
            "长宽高数值超过500CM，数值过大，请重新输入"
          );
        });
        return;
      }
      ScanforOutBound_GetOffModule.setErrorMessage("");
    }
  }

  public GetQueryLockWeight() {
    try {
      let request = {
        devMac: this.globalConfig.LocalMac,
        // devMac: "00000",////测试用，上线前需要注释
        devType: "",
        body: {
          queryValue: this.globalConfig.CompName,
          // queryValue: "摆臂",////测试用，上线前需要注释
          queryType: "34",
          viewType: "",
          extend1: "",
          extend2: "",
          extend3: "",
        },
      };
      let response = JSON.parse(queryLockWeight(JSON.stringify(request)));
      if (
        response != null &&
        response != undefined &&
        response.respcode == "000"
      ) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  private carNumInfo: string = "";

  private NextWebPoint_KeyPress(e) {
    this.form.NextWebPoint = this.form.NextWebPoint.trim().toUpperCase();
    obj_ScanForOutbound_GetOff.nextWebPoint_KeyPress(this.form.NextWebPoint);
  }
}
